import { Box, Container, Grid, Typography, Link, ThemeProvider, CssBaseline } from "@mui/material";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LogoDevIcon from '@mui/icons-material/LogoDev';
import theme from "../Components/theme";

export default function Footer(){
    return(
        <footer>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Box m={2}>
                    <Container maxWidth={"lg"}>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item xs = {12} sm = {12} md = {12} lg = {12} xl = {12}>
                                <Box>
                                    <Typography variant="h4" fontSize={{lg: 45, md: 40, sm: 35, xs: 25}}>ISS Daily Reports</Typography>
                                    <Typography variant="h6" color={"primary"} fontSize={{lg: 22, md: 20, sm: 17, xs: 12}} m={1} fontWeight={800} >Powered by <Link className="Link" href="https://thespacedevs.com/">TheSpaceDevs</Link></Typography>
                                </Box>
                            </Grid>

                            <Grid item xs = {12} sm = {12} md = {12} lg = {12} xl = {12}>
                                <Box m={2.5}>
                                    <Link href="https://github.com/Xhasi"><GitHubIcon color="primary" sx={{ fontSize: 40 }}/></Link>
                                    <Link href="https://www.linkedin.com/in/xhasumzi-maphukatha-dlamini"><LinkedInIcon color="primary" sx={{ fontSize: 40 }} /></Link>
                                    <Link href="https://dev.to/xhasi"><LogoDevIcon color="primary" sx={{ fontSize: 40 }} /></Link>
                                    <Link href="http://Instagram.com/xhasumzi_maphukatha"><InstagramIcon color="primary" sx={{ fontSize: 40 }} /></Link>
                                    <Link href="https://api.whatsapp.com/send?phone=27734193543"><WhatsAppIcon color="primary" sx={{ fontSize: 40 }} /></Link>
                                </Box>
                            </Grid>

                            <Grid item xs = {12} sm = {12} md = {12} lg = {12} xl = {12}alignItems="flex-end">
                                <Box m={2} p={0} b={0}>
                                    <Typography fontSize={{lg: 22, md: 20, sm: 17, xs: 12}}>ISS Daily Reports &reg; {new Date().getFullYear()}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            </ThemeProvider>
        </footer>
    )
}